export default "__VITE_ASSET__BlFy4gGD__"